import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import OpenEndedNumericInput from '../../OpenEndedNumericInput';
import { getRowClass, getInputClass } from '../../utils';
import { QUESTION_MATRIX_OPEN_ENDED_STYLES } from '../../constants';

export default function Columns({
  rowId,
  rowRefId,
  rowOrder,
  columns,
  openEndedStyle,
  openEndedInputSize,
  openEndedSignPlacement,
  openEndedSign,
  min,
  max,
  decimals,
  showRequiredInputSymbol,
}) {
  const answerStyle = getRowClass(openEndedStyle);
  const inputStyle = getInputClass(openEndedInputSize);
  let containerClasses = 'answer--matrix-open-ended-answer-container';

  if (openEndedStyle === QUESTION_MATRIX_OPEN_ENDED_STYLES.VERTICAL) {
    containerClasses += ' answer--matrix-open-ended-answer-container-vertical';
  }

  return (
    <div className={`${answerStyle} scrollbox`}>
      {columns.map((column, index) => (
        <Fragment>
          <div id={column.id} className={containerClasses}>
            <div className="answer--matrix-open-ended-column-label formatted-answers-inline">
              {column.required && showRequiredInputSymbol && (
                <span className="answer--matrix-open-ended-column-required">
                  *
                </span>
              )}
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: column.label || '&nbsp;' }}
              />
            </div>
            <OpenEndedNumericInput
              rowId={rowId}
              rowRefId={rowRefId}
              rowOrder={rowOrder}
              columnId={column.id}
              columnRefId={column.refId}
              columnOrder={index}
              openEndedInputSize={openEndedInputSize}
              openEndedSignPlacement={openEndedSignPlacement}
              openEndedSign={openEndedSign}
              min={min}
              max={max}
              decimals={decimals}
              required={column.required}
              inputStyle={inputStyle}
            />
          </div>
        </Fragment>
      ))}
    </div>
  );
}

Columns.propTypes = {
  rowId: PropTypes.number,
  rowRefId: PropTypes.string,
  rowOrder: PropTypes.number,
  columns: PropTypes.array,
  openEndedStyle: PropTypes.string,
  openEndedInputSize: PropTypes.string,
  openEndedSign: PropTypes.string,
  openEndedSignPlacement: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  decimals: PropTypes.number,
  showRequiredInputSymbol: PropTypes.bool,
};
